import { configureStore } from './store'
import { reset } from './persistence'

export { configureStore, reset }
